"use client";
import Link from "next/link";
import ContentContainer from "../content-container";
import PageSection from "../page-section";
import * as styles from "./styles.css";
import { useMemo } from "react";
import Icon from "@/elements/icons";
import { usePathname } from "next/navigation";

export default function Breadcrumb(props: any) {
  const paths = Object.keys(props);
  const pathname = usePathname();

  const breadCrumbData = useMemo(() => {
    const data = [] as any[];

    if (paths.length > 0) {
      for (let i = 0; i < paths.length; i += 1) {
        if (i === 0) {
          data.push({
            label: `${props[paths[i]].replace(/[^A-Z0-9]/gi, " ")}`,
            href: `/${props[paths[i]].toLowerCase()}`,
          });
        } else if (i === 1) {
          const subpath = data.map((d) => d.href);
          data.push({
            label: `${props[paths[i]].replace(/[^A-Z0-9]/gi, " ")}`,
            href: `${subpath.join("")}/${props[paths[i]].toLowerCase()}`,
          });
        } else if (i === 2) {
          data.push({
            label: `${props[paths[i]].replace(/[^A-Z0-9]/gi, " ")}`,
            href: pathname,
          });
        }
      }
    }

    return data;
  }, [paths, props, pathname]);

  return (
    <PageSection backgroundColor="background-lighten-5">
      <ContentContainer
        layout="breadcrumb"
        alignment="left"
        className={styles.breadcrumbContainer}
      >
        <ul className={styles.listContainer}>
          <li>
            <Link href="/" prefetch={false}>
              <div className={styles.iconContainer}>
                <Icon type="home-unfilled" />
              </div>
            </Link>
            <div className={styles.iconContainer}>
              <Icon type="chevron-right-unfilled" />
            </div>
          </li>
          {breadCrumbData.map((d, index) => {
            if (index < breadCrumbData.length - 1) {
              return (
                <li key={d.href}>
                  <Link href={d?.href ?? "/"} prefetch={false}>
                    {d.label}
                  </Link>
                  <div className={styles.iconContainer}>
                    <Icon type="chevron-right-unfilled" />
                  </div>
                </li>
              );
            } else {
              return (
                <li key={d.href}>
                  <Link
                    className={styles.linkText}
                    href={d?.href ?? "/"}
                    prefetch={false}
                  >
                    {d.label.toLowerCase()}
                  </Link>
                </li>
              );
            }
          })}
        </ul>
      </ContentContainer>
    </PageSection>
  );
}
